import { render, staticRenderFns } from "./HubModal.vue?vue&type=template&id=39e9a1f7"
import script from "./HubModal.vue?vue&type=script&lang=js"
export * from "./HubModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e9a1f7')) {
      api.createRecord('39e9a1f7', component.options)
    } else {
      api.reload('39e9a1f7', component.options)
    }
    module.hot.accept("./HubModal.vue?vue&type=template&id=39e9a1f7", function () {
      api.rerender('39e9a1f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/HubModal.vue"
export default component.exports